import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  remarkField: {
    width: "100%",
  },
});

export default useStyles;
